import axios from "axios";
import { debounce } from "lodash-es";

export default {
  props: ["query"],
  data: function () {
    return {
      q: this.query,
      results: {},
      showSuggestions: false,
      searching: false,
      lastQ: null
    };
  },
  methods: {
    _suggest: debounce(async function () {
      if (this.q) {
        let config = this.$store.state.config;
        let apiUrl = config.suggestApiUrl;
        let result = await axios.get(apiUrl, {
          params: {
            t: config.themeId,
            shop: config.shopDomain,
            q: this.q,
          },
        });
        this.results = result.data;
      }
      this.searching = false;
    }, 200),
    clickaway: function () {
      this.showSuggestions = false;
    },
    suggest: function () {
      this.showSuggestions = true
      if (!this.q) {
        this.showSuggestions = false
        return
      }
      if (this.q != this.lastQ) {
        this.searching = true;
        this._suggest();
        this.lastQ = this.q;
      }
    },
  },
};